import { render, staticRenderFns } from "./custom_index.vue?vue&type=template&id=8720ab34&scoped=true&"
import script from "./custom_index.vue?vue&type=script&lang=js&"
export * from "./custom_index.vue?vue&type=script&lang=js&"
import style0 from "./custom_index.vue?vue&type=style&index=0&id=8720ab34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8720ab34",
  null
  
)

export default component.exports